// extracted by mini-css-extract-plugin
export default {"vars":"'styles/theme/vars.module.css'","phone":"480px","susPenseWrapper":"suspense_susPenseWrapper__CryKI"};